export default __webpack_public_path__ + "static/media/2269-01_open.c1403a4a.jpg";